<template>
  <div>
    <div class="d-flex flex-wrap flex-start ga-1">
      <v-chip v-if="show_places_restantes" color="white" variant="elevated" elevation="0" class=" spo-border">
        <v-icon icon="mdi-account-multiple" color="primary" class="mr-1"></v-icon> {{ places_restantes }} place(s)
        restante(s)
      </v-chip>
      <v-chip v-if="is_discipline_sportif" color="white" variant="elevated" elevation="0" class="spo-border">
        <v-icon icon="mdi-run-fast" color="primary" class="mr-1"></v-icon> {{ discipline }}
      </v-chip>
      <v-chip v-if="show_is_chrono" color="white" variant="elevated" elevation="0" class="spo-border">
        <v-icon icon="mdi-timer-outline" color="primary" class="mr-1"></v-icon>
        {{ is_chrono ? "Chronométré" : "Non chronométré" }}
      </v-chip>
      <v-chip v-if="distance" color="white" variant="elevated" elevation="0" class="spo-border">
        <v-icon icon="mdi-ray-start-arrow" color="primary" class="mr-1"></v-icon> {{ distance }}KM
      </v-chip>
      <v-chip v-if="denivele" color="white" variant="elevated" elevation="0" class="spo-border">
        <v-icon icon="mdi-elevation-rise" color="primary" class="mr-1"></v-icon> {{ denivele }}m D+
      </v-chip>
      <v-chip v-if="course.metadatas?.naissance_min != ''" color="white" variant="elevated" elevation="0"
        class="spo-border">
        <v-icon icon="mdi-calendar-arrow-right" color="primary" class="mr-1"></v-icon>
        {{ "Né après le " +
          $moment(course.metadatas.naissance_min).format("DD/MM/YYYY") }}
      </v-chip>
      <v-chip v-if="course.metadatas?.naissance_max != ''" color="white" variant="elevated" elevation="0"
        class="spo-border">
        <v-icon icon="mdi-calendar-arrow-left" color="primary" class="mr-1"></v-icon> {{ "Né avant le " +
          $moment(course.metadatas.naissance_max).format("DD/MM/YYYY") }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  props: ["course"],
  components: {},
  computed: {
    ...mapStores(useMainStore),
    places_restantes() {
      return this.course.get_places_restantes(this.mainStore.module.courses);
    },
    has_places_restantes() {
      return this.places_restantes > 0;
    },
    is_discipline_sportif() {
      return this.course.metadatas?.discipline != 'Non sportif';
    },
    show_places_restantes() {
      const course_has_max = this.course.has_max_inscrits();
      const hide_inscrits = this.mainStore.module.hide_nb_inscrits;
      return course_has_max && !hide_inscrits && this.has_places_restantes;
    },
    show_is_chrono() {
      const meta_exist = this.course.has_metadata('est_chronometre');
      const is_sportif = this.course.get_metadata('discipline') != 'Non sportif';
      const is_pacours_billetterie = this.mainStore.parcours_billetterie_mode;
      return meta_exist && is_sportif && !is_pacours_billetterie;
    },
    is_chrono() {
      return this.course.get_metadata('est_chronometre') == '1';
    },
    discipline() {
      return this.course.get_metadata('discipline');
    },
    distance() {
      return this.course.has_metadata('distance') && this.course.get_metadata('distance') != '0' ? this.course.get_metadata('distance') : false;
    },
    denivele() {
      return this.course.has_metadata('denivele') && this.course.get_metadata('denivele') != '0' ? this.course.get_metadata('denivele') : false;
    },
  },
  methods: {
  },
};
</script>

<style lang="scss"></style>